import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

/** Charge les fichiers JSON depuis {@code assets/i18n/} (cache-bust version). */
export function httpTranslateLoader(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(
    http,
    './assets/i18n/',
    `.json?v=${environment.appVersion}`
  );
}

/** Charge le français avant le premier rendu (pas de sélecteur de langue). */
export function initializeTranslate(translate: TranslateService) {
  return () => {
    translate.setDefaultLang('fr');
    return firstValueFrom(translate.use('fr'));
  };
}
